import React from "react";
import {
  Grid,
  TableBody,
  CardContent,
  Divider,
  Card,
  TableRow,
  Table
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { IsEmpty, readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const PaytmDetails = ({ data }) => {
  return (
    <Card>

      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item xs={6} >
            Paytm Details
          </Grid>

        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Table className="w-full">
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Order Id</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                    <IsEmpty itemKey={data} value="paytm_order_id"/>
                    </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Mobile No.</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                  <IsEmpty itemKey={data} value="mobile_number"/></TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Paytm Txn Id</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                  <IsEmpty itemKey={data} value="paytm_txn_id"/></TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Paytm Bank Txn Id</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                  <IsEmpty itemKey={data} value="paytm_bank_txn_id"/></TableBodyCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <Table className="w-full">
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Gateway Name</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                  <IsEmpty itemKey={data} value="gateway_name"/></TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
                <TableRow>
                  <TableBodyCell className="common_table_title">Bank Name</TableBodyCell>
                  <TableBodyCell className="common_table_content">
                  <IsEmpty itemKey={data} value="bank_name"/></TableBodyCell>
                </TableRow>
              </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Payment Mode</TableBodyCell>
                    <TableBodyCell className="common_table_content"><IsEmpty itemKey={data} value="payment_mode"/></TableBodyCell>
                  </TableRow>
                </TableBody>
                <TableBody>
                  <TableRow>
                    <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                    <TableBodyCell className="common_table_content">{readableFormatDate(data["created_at"])}</TableBodyCell>
                  </TableRow>
                </TableBody>
            </Table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
      </Card>

      );
};
